export default __webpack_public_path__ + "static/media/facebookLogo.d2405338.svg";